document.addEventListener('DOMContentLoaded', () => {
  window.initSwiper = function () {
    new Swiper('.card__media .product-card-swiper.swiper', {
      a11y: true,
      direction: 'horizontal',
      slidesPerView: 1,
      nested: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };

  initSwiper();
});